//PRD
const config = {
  GetLeadMasterData_URL: "https://scgpcrm-prd-rg-fa-webcustomapiservice.azurewebsites.net/api/getmasterdatafile?code=UFzAPjyE79tmvAwdmVNLPyx3PWDC7d/mfLHLXtWAANlOjanSTNsYQA==",
  GetActivePurposes_URL: "https://scgpcrm-prd-rg-fa-webcustomapiservice.azurewebsites.net/api/GetActivePurposes?code=UFzAPjyE79tmvAwdmVNLPyx3PWDC7d/mfLHLXtWAANlOjanSTNsYQA==",
  CreateLeadRecord_URL: "https://scgpcrm-prd-rg-fa-webcustomapiservice.azurewebsites.net/api/CreateLeadRecord?code=UFzAPjyE79tmvAwdmVNLPyx3PWDC7d/mfLHLXtWAANlOjanSTNsYQA==",
  UploadFileToSharepoint_URL: "https://scgpcrm-prd-rg-fa-sharepointservices.azurewebsites.net/api/uploadfile?code=NQRHXu3puh_mXB8neZRFOYexeUraTgl-RS6vEaIYQrqyAzFuZjGE_w=="
};

//UAT
// const config = {
//   GetLeadMasterData_URL: "https://scgpcrm-uat-rg-fa-customwebapiservice.azurewebsites.net/api/getmasterdatafile?code=DIh5qhsxaGXx0iCOxRb/8J8v/LE7bv1sAt211X9AAF5hVZqorSDNew==",
//   GetActivePurposes_URL: "https://scgpcrm-uat-rg-fa-customwebapiservice.azurewebsites.net/api/GetActivePurposes?code=DIh5qhsxaGXx0iCOxRb/8J8v/LE7bv1sAt211X9AAF5hVZqorSDNew==",
//   CreateLeadRecord_URL: "https://scgpcrm-uat-rg-fa-customwebapiservice.azurewebsites.net/api/CreateLeadRecord?code=DIh5qhsxaGXx0iCOxRb/8J8v/LE7bv1sAt211X9AAF5hVZqorSDNew==",
//   UploadFileToSharepoint_URL: "https://scgpcrm-uat-rg-fa-sharepointservices.azurewebsites.net/api/uploadfile?code=RXFCvg7k7XUnWj2G2NwMeltLHcyf2jXzcXVNxtMSXaFtAzFuwdXIAA=="
// };

export default config;

